module.exports = __webpack_public_path__ + "img/user-outline-grey.9b278579.svg";